import React from 'react';
import './CTA.css';

const CTA = () => {
  return (
    <section className="cta-section">
      <div className="cta-container">
        <h2 className="cta-title">Ready to Find Your Dream Home?</h2>
        <p className="cta-description">
          Connect with Swayam Homes today and explore premium residential opportunities 
          tailored to your lifestyle and budget.
        </p>
        
        <div className="cta-buttons">
          <a href="https://wa.me/919297971919?text=Hi%20Swayam%20Homes%21%20I%20am%20interested%20in%20learning%20more%20about%20your%20projects." 
             target="_blank" 
             rel="noopener noreferrer"
             className="cta-btn whatsapp">
            💬 Chat on WhatsApp
          </a>
          <a href="/contact" className="cta-btn contact">
            📞 Contact Us
          </a>
        </div>

        <p className="cta-footer">
          Response within 24 hours | Available 7 days a week
        </p>
      </div>
    </section>
  );
};

export default CTA;
